// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__q_GtZ","list":"BalanceDue_list__2ZYPl","listRow":"BalanceDue_listRow__1d9ge","total":"BalanceDue_total__KyWWh"};